(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["back-to-top"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    let backToTopButton = document.querySelector('[data-shopify-block-id="{{ block.id }}"] .back-to-top') || document.querySelector('.back-to-top');

    if (!backToTopButton) return;

    // Move button to body to escape any container stacking contexts
    const buttonClone = backToTopButton.cloneNode(true);
    backToTopButton.remove();
    document.body.appendChild(buttonClone);
    backToTopButton = buttonClone;

    // Show/hide button based on scroll position
    const handleScroll = function() {
      if (window.scrollY > 300) {
        backToTopButton.classList.add('visible');
      } else {
        backToTopButton.classList.remove('visible');
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Scroll to top when clicked
    backToTopButton.addEventListener('click', function(e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });

    // Initial check
    handleScroll();
  });
  } catch(e) { console.error(e); }
})();

})();
